<template>
  <b-modal
    title="Update product"
    @shown="LoadProduct"
    @ok="UpdateProduct"
    id="productEdit"
  >
    <div v-if="loading">Loading....</div>

    <div v-else>
      <b-form-group label="Name">
        <b-form-input class="form-control" v-model="product.name" required />
      </b-form-group>
      <b-form-group label="SKU">
        <b-form-input class="form-control" v-model="product.sku" required />
      </b-form-group>
      <b-form-group label="Barcode">
        <b-form-input class="form-control" v-model="product.barcode" />
      </b-form-group>
      <b-form-group label="Category">
        <b-form-input class="form-control" v-model="product.category" />
      </b-form-group>
      <b-form-group label="Unit price">
        <b-form-input
          class="form-control"
          v-model="product.unitPrice"
          type="number"
          step="0.01"
        />
      </b-form-group>
      <b-form-group label="Cost price">
        <b-form-input
          class="form-control"
          v-model="product.costPrice"
          type="number"
          step="0.01"
        />
      </b-form-group>
      <b-form-group label="Tax / VAT rate (%)">
        <b-form-input
          class="form-control"
          v-model="product.taxRate"
          type="number"
          min="0"
          max="100"
          step="0.01"
        />
      </b-form-group>
      <b-form-group label="Opening stock qty">
        <b-form-input
          class="form-control"
          v-model="quantity"
          type="number"
          min="0"
          step="1"
        />
        <b-form-text>
          Stock for the current store: {{ selectedStoreName }}
        </b-form-text>
      </b-form-group>
    </div>

    <template #modal-footer="{ ok, cancel }">
      <icon-button
        :func="() => cancel()"
        :icon="'times'"
        :title="'Cancel'"
        :classes="'akkurate-danger-bg btn-size2'"
        :btnName="'Cancel'"
        :disabled="loading || saving"
      />
      <icon-button
        :func="() => ok()"
        :icon="'check'"
        :title="'Save'"
        :classes="'akkurate-green-btn btn-size2'"
        :btnName="'Save'"
        :disabled="loading || saving"
      />
    </template>
  </b-modal>
</template>

<script>
import ApiService from "@/core/services/api.service";
import IconButton from "@/components/IconButton.vue";

export default {
  name: "ProductEdit",
  props: ["productId", "selectedStoreName", "storeId"],
  computed: {},
  components: {
    IconButton,
  },
  data() {
    return {
      product: {},
      loading: true,
      saving: false,
      quantity: 0,
    };
  },

  methods: {
    async LoadProduct() {
      this.quantity = 0;
      try {
        this.loading = true;
        await ApiService.get("products/" + this.productId, {
          store_id: this.storeId,
        }).then((res) => {
          console.log(res);
          this.product = res;

          this.quantity = res.stock.quantity || 0;
          this.loading = false;
        });
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },

    async UpdateProduct(bvModalEvt) {
      bvModalEvt.preventDefault();
      try {
        this.saving = true;
        await ApiService.put("products/" + this.productId, {
          ...this.product,
          quantity: this.quantity,
          store_id: this.storeId,
        }).then((res) => {
          console.log(res);
          this.$emit("updated");
          this.$bvModal.hide("productEdit");
          this.saving = false;
          toast.fire({ title: "Product Updated", icon: "success" });
        });
      } catch (e) {
        toast.fire({
          title: e?.response?.data?.message || "Update failed",
          icon: "danger",
        });
        this.saving = false;
      }
    },
  },
};
</script>
